import { ChakraBox, ChakraFlex, EquipUITheme } from '@equip.health/ui';

import {
  NOTIFICATION_HEADER_STYLES,
  NotificationEventType,
  NotificationStatus,
} from '~/lib/constants/notifications.constants';
import { getNotificationText } from '~/lib/util/notification.util';

import NotificationUserDetail from './NotificationUserDetail';
import NotificationTimeStamp from '../NotificationTimeStamp';

const TOP_LEVEL_ID = 'notification-user';

interface NotificationUserProps {
  channelName?: string;
  createdAt?: string;
  dob?: string;
  eventType?: NotificationEventType;
  isRead?: boolean;
  notificationExternalId?: string;
  onUpdateNotification?: (
    notificationExternalIds: Array<string>,
    status: NotificationStatus,
  ) => void;
  patientName?: string;
}

const { paragraph, paragraphBold } = EquipUITheme.typography;

const NotificationUser = ({
  channelName,
  createdAt,
  dob,
  eventType,
  isRead,
  notificationExternalId,
  onUpdateNotification,
  patientName,
}: NotificationUserProps) => {
  return (
    <>
      <ChakraFlex alignItems="start" justifyContent="space-between">
        <ChakraBox
          {...paragraph}
          id={`${TOP_LEVEL_ID}-header`}
          {...NOTIFICATION_HEADER_STYLES}
        >
          <span>
            {getNotificationText(eventType)}&nbsp;
            <span style={{ ...paragraphBold, lineHeight: '16.8px' }}>
              {channelName}
            </span>
            &nbsp;of
          </span>
        </ChakraBox>
        <NotificationTimeStamp
          createdAt={createdAt}
          isRead={isRead}
          notificationExternalId={notificationExternalId}
          onUpdateNotification={onUpdateNotification}
        />
      </ChakraFlex>
      <NotificationUserDetail dob={dob} patientName={patientName} />
    </>
  );
};

export default NotificationUser;
